import React, {useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from '@hookform/error-message';
import { InputStandard, InputMultiline, InputSelect, InputSimple, ButtonSimple } from "../globalComponents/inputs/inputs";
import { Uploader } from "../globalComponents/uploader/Uploader";
import { Box, Typography, CircularProgress, Paper, Modal } from '@mui/material';
import { createApp } from "../globalComponents/connections";
import { allAppsContext } from "../../App";
import { ClaimSite } from "./FormClaimSite";
import { SnackbarBasic } from "../globalComponents/feedBacks/FeedBacks";
import { useNavigate } from "react-router-dom";

const styles = {
    box:{
        display: "Flex",
        justifyContent: "center",
        padding: {xs: "0", md:"2%"},
        flexDirection: "column",
        gap: 1,
    },
    paper: {
        display: "Flex",
        flexDirection: "column",
        gap: 1,
        alignSelf:{md: "center"},
        alignItems:{sm: "center"},
        width:{xs: "100%", md: "70%"},
    },
    form : {
        display: "Flex",
        flexDirection: "column",
        margin: "10px",
        width: {sm:"50%", md: "70%", lg: "100%"},
    },
    h3: {
        fontSize: "18px", 
        textAlign: "initial",
        margin: "5%",
        fontWeight: "700",
    },
    text: {
        fontSize: "12px", 
        textAlign: "initial",
        alignSelf: {md: "center"},
        margin: {xs:"5%", md: 0},
        fontWeight: "500",
        width: {xs: "323px", sm: "400px"},
    },
    input: {
        marginY: "5px",
        marginLeft: {xs:"15px", sm: "30px", lg: 0},
        borderBottom: "1px solid #000000",
        alignSelf: {md: "center"},
        width: {xs: "323px", sm: "400px"},
        "& .MuiInput-underline:after": {
            borderBottomColor: "#000000"
         },
    },
    multiline: {
        marginY: "5px",
        border: "1px solid #000000",
        width: {xs: "323px", sm: "400px"},
        "& .MuiInputBase-multiline": {
            borderBottomColor: "#000000"
         },
        div: {
            margin: {xs:"5%", md: 0},
            alignSelf: {md: "center"},
            width: {xs: "333px", sm: "410px"},
        }
    },
    select : {
        width: "141px",
        height: "32px",
        border: "1px solid #DADEE3",
        borderRadius: "15px",
        color: "#7C7C7C",
        marginTop: "10px",
    },
    inputSimple:{
        marginTop: "5px",
        marginBottom: "30px",
        width: {xs: "323px", sm: "400px"},
        alignSelf: {md: "center"},
        fieldset: {
            borderRadius: "15px",
          },
        div:{
            alingItems: "center",
            width: {xs: "333px", sm: "410px"},
        },    
    },
    buttonSubmit: {
        marginY: "30px",
        width: "343px",
        height: "44px",
        borderRadius: "15px",
        background: "#262626",
        ":hover": {
            background: "#262626",
        },
        div:{
            alignSelf: "center",
            width: "100%", 
            textAlign: "center"
        },        
    },
    error: {
        fontSize: "12px",
        color: "red",
        fontWeight: "bold",
        width: "90%",
        overflow: "hidden",
        alignSelf: "center"
    },
    modal:{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {xs:300, sm:500},
        bgcolor: 'background.paper',
        border: '1px solid #000',
        boxShadow: 24,
        p: 4,
    }
}

const dataLanguage = [
    {
        id: "001",
        value: "English",
        text: "English",
    },
    {
        id: "002",
        value: "Spanish",
        text: "Spanish",
    },
]

export const FormNewApp = () => {
    const navigate = useNavigate
    const { dataUser } = useContext(allAppsContext)
    const [showModal, setShowModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [valueSelect, setValueSelect] = useState("English")
    const [dataOtp, setDataOtp] = useState({})
    const [colorText, setColorText] = useState({
        one: "#747B84",
        two: "#747B84",
        three: "#747B84",
        four: "#747B84",
    })
    const [textInput, setTextInput] = useState({
        one: "“Mobile web apps” are websites that function in-browser in a way similar to that of content downloaded from app stores.",
        two: "",
        three:"If you´re the owner of this web app, please enter an email (using the site´s URL) to activate admin access.",
        four: "",
    })

    const { register, handleSubmit, watch, formState: { errors }, reset} = useForm();
    const err = errors.user === undefined ? {} : errors.user
    const mediaLogo = watch("user.imageLogo")
    const mediaOne = watch("user.imageOne")
    const mediaTwo = watch("user.imageTwo")
    const mediaThree = watch("user.imageThree")
    const mediaFour = watch("user.imageFour")

    //Select Language
    const handleLanguage = (event) => {
        setValueSelect(event.target.value)
    }

    const handleClose = () => {setShowModal(false)}

    const validation = (user) => {
        const xuser = JSON.parse(localStorage.xuser)
        let words = user.keywords.split(',')
        let url = user.url.replace("https://www.", "").replace("http://www.", "").replace("www.", "")
        const formData = new FormData();
        if(user.admin_email.length !== 0){
            const newSite = {
                url: "https://www." + url,
                description: user.description,
                language: valueSelect,
                name: user.name,
                keywords: words, 
                user_id: xuser._id,    
                admin_email:user.admin_email
            }
            formData.append('json', JSON.stringify(newSite));
        } else {
            const newSite = {
                url: "https://www." + url,
                description: user.description,
                language: valueSelect,
                name: user.name,
                keywords: words, 
            }    
            formData.append('json', JSON.stringify(newSite));
        }

        if(user.imageLogo.length > 0){
            const file = new File([user.imageLogo.item(0)], user.imageLogo.item(0).name, {
                type: user.imageLogo.item(0).type
            });
            formData.append('icon', file);
        }
        if(user.imageOne !== undefined && user.imageOne.length > 0){
            const file = new File([user.imageOne.item(0)], user.imageOne.item(0).name, {
                type: user.imageOne.item(0).type
            });
            formData.append('media', file);
        }
        if(user.imageTwo !== undefined && user.imageTwo.length > 0){
            const file = new File([user.imageTwo.item(0)], user.imageTwo.item(0).name, {
                type: user.imageTwo.item(0).type
            });
            formData.append('media', file);
        }
        if(user.imageThree !== undefined && user.imageThree.length > 0){
            const file = new File([user.imageThree.item(0)], user.imageThree.item(0).name, {
                type: user.imageThree.item(0).type
            });
            formData.append('media', file);
        }
        if(user.imageFour !== undefined && user.imageFour.length > 0){
            const file = new File([user.imageFour.item(0)], user.imageFour.item(0).name, {
                type: user.imageFour.item(0).type
            });
            formData.append('media', file);
        }
        return formData
    }

    const onSubmit = ({user}) => {
        if(localStorage.xuser){
            const xuser = JSON.parse(localStorage.xuser)
            let url = user.url.replace("https://www.", "").replace("http://www.", "").replace("www.", "")
            setDataOtp({
                user_id: xuser._id,
                site_url: "https://www." + url,
                email: user.admin_email
            })
            if(!loading){
                setLoading(true)
                const userValidator = validation(user)
                createApp(userValidator, setTextInput, setColorText, setLoading, dataUser, setShowModal,setOpenSnackbar, reset, navigate)
            }
        }
    }

    return(
        <Box sx={styles.box}>
            <Paper sx={styles.paper} elevation={0}>
                <form onSubmit={handleSubmit(onSubmit)} style={styles.form} >
                    <Typography variant="h3" sx={{fontSize: "18px", textAlign: "initial", marginX:"5%", marginTop:"5%", marginBottom: "2%", fontWeight: "700"}}>App Name</Typography>
                    <InputStandard 
                        styles={styles.input}
                        error={err.name ? true : false}
                        inputProps={{ maxLength: 40 }}
                        hookForm={{...register("user.name", {required: "This field can´t be empty"})}}/>
                    <ErrorMessage errors={errors} name="user.name" render={({message}) => (<span style={styles.error}>{message}</span>)}/>
                    <Typography variant="h3" sx={styles.h3}>Mobile Web URL </Typography>
                    <InputStandard 
                        placeholder={"http(s)://www.example.com"} 
                        styles={styles.input}
                        error={err.url ? true : false}
                        hookForm={{...register("user.url", {
                            required: "This field can´t be empty"
                    })}}/>
                    <ErrorMessage errors={errors} name="user.url" render={({message}) => (<span style={styles.error}>{message}</span>)}/>
                    <Typography variant="body2" color={colorText.one} sx={styles.text}>{textInput.one} </Typography>
                    <Box style={{display: "flex", marginTop: {md:"15px"}}}>
                        <Typography variant="h3" sx={styles.h3}>Do you own this web app?</Typography>
                        <Typography variant="body2" sx={{ fontSize: "12px", textAlign: {xs:"initial", sm: "end"}, alignSelf: {md: "center"}, margin: {xs:"5%", md: 0}, fontWeight: "500", width: {xs: "57px", sm: "210px", md: "135px"}}}><span style={{color: "red"}}>*</span> Optional</Typography>
                    </Box>
                    <InputStandard 
                        placeholder={"admin@example.com"}  
                        styles={styles.input}
                        error={err.admin_email ? true : false}
                        hookForm={{...register("user.admin_email", {
                            pattern: {
                                value: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
                                message: "Please, Enter a valid email"
                            } })}}/>
                    <ErrorMessage errors={errors} name="user.admin_email" render={({message}) => (<span style={styles.error}>{message}</span>)}/>
                    <Typography variant="body2"  color={colorText.three}  sx={styles.text}>{textInput.three}</Typography>
                    <Typography variant="h3" sx={styles.h3}>Brief description</Typography>
                    <InputMultiline 
                        placeholder={"Description"} 
                        styles={styles.multiline}
                        inputProps={{maxLength: 500, borderRadius: "15px" }}
                        error={err.description ? true : false}
                        hookForm={{...register("user.description", {required: "This field can´t be empty"} )}}/>
                    <ErrorMessage errors={errors} name="user.description" render={({message}) => (<span style={styles.error}>{message}</span>)} />
                    <Box sx={{display: "flex", alignSelf: {md:"center"}, marginTop: "30px"}}>
                        <Typography variant="body2" sx={{ fontSize: "12px", textAlign: "initial", margin: {xs:"5%", md: 0},fontWeight: "500",width: {xs: "323px", sm: "250px"}}}>Description language:</Typography>
                        <InputSelect value={valueSelect} styles={styles.select} onChange={handleLanguage} data={dataLanguage}/>
                    </Box>
                    <Typography variant="body2"  color={colorText.two}  sx={styles.text}>{textInput.two}</Typography>
                    <div style={{display: "flex", gap: "2rem", marginTop: "15px"}}>
                        <Typography variant="h3" sx={styles.h3}>Keywords</Typography>
                        <Typography variant="body2" sx={{ fontSize: "12px", textAlign: "initial", alignSelf: {md: "center"}, marginY: {xs:"5%", md: 0}, fontWeight: "500", width: {xs: "323px", sm: "440px"}}}>(When editing an app, comas are placed for differentiating keywords)</Typography>
                    </div>
                    <InputSimple                         
                        placeholder={"Description"} 
                        type={"text"} 
                        inputProps={{maxLength: 40, borderRadius: "15px" }}
                        styles={styles.inputSimple}
                        error={err.keywords ? true : false}
                         hookForm={{...register("user.keywords", {required: "This field can´t be empty"} )}}/>
                    <ErrorMessage errors={errors} name="user.keywords" render={({message}) => (<span style={styles.error}>{message}</span>)}/>
                    <Typography variant="h3" sx={styles.h3} marginTop={4}>App Logo</Typography>
                    {/*Image Logo*/}
                    <Box sx={{display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "start", paddingLeft: {xs:"1.5rem", md: "6.5rem"}}}>
                        <Uploader text={"Upload"} media={mediaLogo} hookForm={{...register("user.imageLogo")}}/>
                    </Box>
                    <Typography variant="h3" sx={styles.h3} marginTop={4}>Upload up to 4 screenshots:</Typography>
                    <Box sx={{display: "grid", alignSelf: {md: "center"},  marginLeft: "20px", marginBottom: "30px", gap: 2, gridTemplateColumns: "150px 150px", gridTemplateRows: "50px 50px"}}>
                        <Uploader text={"Upload"} media={mediaOne} hookForm={{...register("user.imageOne")}}/>
                        <Uploader text={"Upload"} media={mediaTwo}   hookForm={{...register("user.imageTwo")}}/>
                        <Uploader text={"Upload"}  media={mediaThree}   hookForm={{...register("user.imageThree")}}/>
                        <Uploader text={"Upload"}  media={mediaFour}   hookForm={{...register("user.imageFour")}}/>
                    </Box>
                    <Typography variant="body2" sx={{ fontSize: "12px", textAlign: "initial", alignSelf: {md: "center"}, margin: {xs:"5%", md: 0}, fontWeight: "500", width: {xs: "350px"}}}>Screenshots should not reveal sensitive account information.</Typography>
                    <ButtonSimple text={loading ? <CircularProgress color="inherit"/> : "Submit"} type={"submit"} styles={styles.buttonSubmit}/>
                    <SnackbarBasic open={openSnackbar} styles={{ width: "200px"}} autoHideDuration={5000} severity={"success"} message={"App created successfully"} vertical={"bottom"} horizontal={"center"}/>
                    <Typography variant="body2"  color={colorText.four}  sx={styles.text}>{textInput.four}</Typography>
                </form>
                <Modal open={showModal} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={styles.modal}>
                        <ClaimSite setShow={setShowModal} resetForm={reset} dataOtp={dataOtp} setDataOtp={setDataOtp}/>
                    </Box>
                </Modal>
            </Paper>
        </Box>
    )
}